import { ParentContext } from 'global/cnr/contexts/ParentContext'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import React, { useContext, useEffect, useState } from 'react'
import UiSaveButtons from '../buttons/UiSaveButtons'
import { AppTimestampContext } from 'global/cnr/contexts/AppTimestampContext'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import { useCacheDataManager } from 'global/cnr/contexts/useHelpers/useCacheDataManager'
import WrapperVertCols from 'global/wrappers/WrapperVertCols'
import { Label } from 'semantic-ui-react'
import { openExternal } from 'global/viewSettings/helpers/settingsLinks'

export const CacheDashboard = () => {

  // parentContext
  const parentContext = useContext(ParentContext)

  const { appTimestamp_state } = useContext(AppTimestampContext) ?? {};
  const { timestampInfo } = appTimestamp_state ?? {};
  const { timestamps: timestamps_db } = timestampInfo ?? {};

  const cdm = useCacheDataManager()

  const [allCacheKeys, setAllCacheKeys] = useState({})
  const [selectedCacheKey, setSelectedCacheKey] = useState('')
  const [selectedCacheGroup, setSelectedCacheGroup] = useState({})

  const [selectedCacheGroupItemKey, setSelectedCacheGroupItemKey] = useState('')
  const [selectedCacheGroupItem, setSelectedCacheGroupItem] = useState({})

  const [selectedCacheGroupDataKey, setSelectedCacheGroupDataKey] = useState('')
  const [selectedCacheGroupData, setSelectedCacheGroupData] = useState({})

  const [selectedTimestamp, setSelectedTimestamp] = useState({})
  const [selectedGroup, setSelectedGroup] = useState({})


  useEffect(() => {
    cdm.getAllKeys().then(allKeys => {
      setAllCacheKeys(allKeys)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateTimestamps = () => {

  }

  const handleExternal = (item) => {
    openExternal.db({}, false, ['_timeStamps', 'ts'])
  }

  const oc_cacheKeys = (item) => {
    cdm.getGroup(item).then(results => {
      setSelectedCacheKey(item)
      setSelectedCacheGroup(results)
      setSelectedCacheGroupItemKey('')
      setSelectedCacheGroupItem({})
      setSelectedCacheGroupDataKey('')
      setSelectedCacheGroupDataKey({})
    })
    // setSelectedTimestamp(item)
  }

  const oc_cacheGroup = async (item) => {
    // console.log('item', item)
    cdm.getSubItem(selectedCacheKey, item?.key).then(results => {
      setSelectedCacheGroupItemKey(item?.key)
      setSelectedCacheGroupItem(results)
      setSelectedCacheGroupDataKey('')
      setSelectedCacheGroupDataKey({})
    })
  }

  const oc_cacheGroupItem = async (item) => {
    setSelectedCacheGroupDataKey(item)
    console.log('selectedCacheGroupItem?.[item]', selectedCacheGroupItem?.[item])
    setSelectedCacheGroupData(selectedCacheGroupItem?.[item])
  }

  const wrapper_cacheKeys = () => <Wrapper
    header={'Cache Groups'}
    content={<ItemMenuSquares menuItems={allCacheKeys} onClick={oc_cacheKeys} activeItem={selectedCacheKey} imsType={_imsTypes.inline} />}
    footer={<UiSaveButtons save={{ oc: handleExternal, caption: 'Open Timestamps' }} />}
    wrapperType={wrapperTypes.padded}
    css={{ content: 'quick-view' }}
  />

  const wrapper_cacheGroup = () => <Wrapper
    header={`Cache Group: ${selectedCacheKey}`}
    content={<ItemMenuSquares menuItems={selectedCacheGroup} activeItem={selectedCacheGroupItemKey} onClick={oc_cacheGroup} imsType={_imsTypes.inline} ignoreStartCase={true} />}

    wrapperType={wrapperTypes.padded}
    css={{ content: 'quick-view' }}
  />

  const fnAlt = (item) => {
    switch (item) {
      case '_timestamp':
        const ts_db = timestamps_db?.[selectedCacheKey]?.[selectedCacheGroupItemKey]
        const ts_cache = selectedCacheGroupItem?.[item]

        const ts_equal = ts_db != null && ts_cache != null && ts_db === ts_cache
        const db_newer = ts_db != null && ts_cache != null && ts_db > ts_cache
        const ts_diff = Math.abs(ts_db - ts_cache)
        const diff_days = Math.floor(ts_diff / 86400000)
        const diff_minutes = Math.floor((ts_diff % 86400000) / 60000)
        const diff_seconds = Math.floor((ts_diff % 60000) / 1000)

        return (
          <Label size='tiny' color={ts_equal ? 'green' : db_newer ? 'red' : 'blue'}>
            {ts_cache} ({diff_days}d {diff_minutes}m {diff_seconds}s))
          </Label>
        )
    }
  }

  const wrapper_cacheGroupItem = () => <Wrapper
    header={'Cache Group Item'}
    content={<ItemMenuSquares fn_altContent={fnAlt} menuItems={_.keys(selectedCacheGroupItem)} activeItem={selectedCacheGroupDataKey} onClick={oc_cacheGroupItem} imsType={_imsTypes.inline} ignoreStartCase={true} />}
    // footer={<UiSaveButtons save={{ oc: updateTimestamps, caption: 'Update Timestamps' }} />}
    wrapperType={wrapperTypes.padded}
    css={{ content: 'quick-view' }}
  />

  const wrapper_cacheGroupData = () => <Wrapper
    header={'Cache Group Data'}
    content={<ItemMenuSquares menuItems={selectedCacheGroupData} imsType={_imsTypes.inline} ignoreStartCase={true} />}
    footer={<UiSaveButtons save={{ oc: updateTimestamps, caption: 'Update Timestamps' }} />}
    wrapperType={wrapperTypes.padded}
    css={{ content: 'quick-view' }}
  />

  const content = () => <WrapperVertCols mvc={'4'}>
    {wrapper_cacheKeys()}
    {wrapper_cacheGroup()}
    {wrapper_cacheGroupItem()}
    {wrapper_cacheGroupData()}
  </WrapperVertCols>

  return content()
}
